import { app } from '../app'
import { createApp } from 'vue'
import { vuetify } from '../vuetify'
import { errorMixin } from '../mixins/error-mixin'
import { i18n } from '../i18n'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import VFormShoppingCart from '../components/VFormShoppingCart.vue'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

createApp({
  components: {
    VFormShoppingCart
  },
  extends: app,
  mixins: [errorMixin]
})
  .use(vuetify)
  .use(i18n)
  .use(pinia)
  .mount('#app')
